// src/components/Listener/LoginToastListener.js
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LoginToastListener = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const toastShown = useRef(false);
    const toastIdRef = useRef(null);

    // Dismiss toast on unmount
    useEffect(() => {
        return () => {
            if (toastIdRef.current) toast.dismiss(toastIdRef.current);
        };
    }, []);

    // Listen for toast messages in URL
    useEffect(() => {
        if (!location.search) return;

        const params = new URLSearchParams(location.search);
        const msg = params.get("msg");
        if (!msg || toastShown.current) return;

        toastShown.current = true;
        const type = params.get("type") || "default";
        const isMobile = window.innerWidth <= 768;
        const isLoginPage = location.pathname === "/login";

        const config = {
            position: isMobile ? "bottom-center" : "top-right",
            autoClose: isLoginPage ? 2500 : (isMobile ? 3000 : 5000),
            hideProgressBar: isMobile,
            closeOnClick: true,
            pauseOnHover: !isMobile,
            draggable: !isMobile,
            theme: isMobile ? "dark" : "light",
            onClose: () => {
                toastShown.current = false;
                toastIdRef.current = null;
            }
        };

        // Remove toast params from URL
        params.delete("msg");
        params.delete("type");
        const newSearch = params.toString() ? `?${params.toString()}` : "";
        navigate(location.pathname + newSearch, { replace: true });

        setTimeout(() => {
            try {
                switch (type) {
                    case "success":
                        toastIdRef.current = toast.success(msg, config);
                        break;
                    case "error":
                        toastIdRef.current = toast.error(msg, config);
                        break;
                    case "info":
                        toastIdRef.current = toast.info(msg, config);
                        break;
                    case "warning":
                        toastIdRef.current = toast.warn(msg, config);
                        break;
                    default:
                        toastIdRef.current = toast(msg, config);
                }
            } catch (e) {
                toastShown.current = false;
            }
        }, 100);
    }, [location, navigate]);

    return (
        <>
            <style>
                {`
                .Toastify__toast-container--bottom-center {
                    bottom: 60px !important;
                }
                @media (max-width: 768px) {
                    .Toastify__toast {
                        border-radius: 25px !important;
                        min-height: 40px !important;
                        max-width: 280px !important;
                        margin: 0 auto !important;
                        padding: 8px 16px !important;
                        background-color: rgba(50, 50, 50, 0.95) !important;
                        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3) !important;
                        font-family: 'Roboto', sans-serif !important;
                        font-size: 14px !important;
                        color: white !important;
                        text-align: center !important;
                    }
                    .Toastify__toast-body {
                        padding: 0 !important;
                        font-weight: 400 !important;
                    }
                    .Toastify__close-button {
                        display: none !important;
                    }
                }
                `}
            </style>
            <ToastContainer containerId="global-toast" />
        </>
    );
};

export default LoginToastListener;